import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=24ebf1f1&scoped=true"
var script = {}
import style0 from "./Partner.vue?vue&type=style&index=0&id=24ebf1f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebf1f1",
  null
  
)

export default component.exports